//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    list: Array,
    borderIntent: {
      type: Boolean,
      default: true
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/cell-form-preview/index.vue